// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.104.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.104.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `pre {
  border-radius: 4px;
  background-color: #191c27;
  padding: 16px;
  font-size: 14px;
  margin-bottom: 24px;
}

code[class*='language-'],
pre[class*='language-'] {
  color: rgb(191, 199, 213);
  font-family: Inconsolata, Monaco, Consolas, 'Courier New', Courier, monospace;
  direction: ltr;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  line-height: 1.5;
  tab-size: 4;
  hyphens: none;
}

/* Code blocks */
pre[class*='language-'] {
  padding: 1em;
  margin: 0.5em 0;
  overflow: auto;
  border-radius: 0.3em;
}

:not(pre) > code[class*='language-'],
pre[class*='language-'] {
  background: #1d1f21;
}

/* Inline code */
:not(pre) > code[class*='language-'] {
  padding: 0.1em;
  border-radius: 0.3em;
}

.token.prolog {
  color: rgb(0, 0, 128);
}

.token.parameter {
  color: rgb(255, 255, 255);
}

.token.comment {
  color: rgb(106, 153, 85);
}

.token.doctype {
  color: rgb(191, 199, 213);
}

.token.cdata {
  color: rgb(191, 199, 213);
}

.token.punctuation {
  color: rgb(136, 198, 190);
}

.token.property {
  color: rgb(252, 146, 158);
}

.token.tag {
  color: rgb(252, 146, 158);
}

.token.class-name {
  color: rgb(250, 200, 99);
}

.token.boolean {
}

.token.constant {
  color: rgb(100, 102, 149);
}

.token.symbol {
  color: rgb(141, 200, 145);
}

.token.deleted {
  color: rgb(141, 200, 145);
}

.token.number {
  color: rgb(181, 206, 168);
}

.token.inserted {
  color: rgb(181, 206, 168);
}

.token.selector {
  color: rgb(215, 186, 125);
}

.token.char {
  color: rgb(209, 105, 105);
}

.token.builtin {
  color: rgb(197, 165, 197);
}

.token.changed {
  color: rgb(197, 165, 197);
}

.token.keyword {
  color: rgb(197, 165, 197);
}

.token.string {
  color: rgb(195, 232, 141);
}

.token.attr-name {
  color: rgb(156, 220, 254);
}

.token.variable {
  color: rgb(156, 220, 254);
}

.token.operator {
  color: #ededed;
}

.token.entity {
  color: #ffffb6;
  cursor: help;
}

.token.url {
  color: #96cbfe;
}

.language-css .token.string,
.style .token.string {
  color: #87c38a;
}

.token.atrule,
.token.attr-value {
  color: #f9ee98;
}

.token.function {
  color: rgb(121, 182, 242);
}

.token.regex {
  color: #e9c062;
}

.token.important {
  color: #fd971f;
}

.token.important,
.token.bold {
  font-weight: bold;
}

.token.italic {
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/prism.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,6EAA6E;EAC7E,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;AACA;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["pre {\n  border-radius: 4px;\n  background-color: #191c27;\n  padding: 16px;\n  font-size: 14px;\n  margin-bottom: 24px;\n}\n\ncode[class*='language-'],\npre[class*='language-'] {\n  color: rgb(191, 199, 213);\n  font-family: Inconsolata, Monaco, Consolas, 'Courier New', Courier, monospace;\n  direction: ltr;\n  text-align: left;\n  white-space: pre;\n  word-spacing: normal;\n  word-break: normal;\n  line-height: 1.5;\n  tab-size: 4;\n  hyphens: none;\n}\n\n/* Code blocks */\npre[class*='language-'] {\n  padding: 1em;\n  margin: 0.5em 0;\n  overflow: auto;\n  border-radius: 0.3em;\n}\n\n:not(pre) > code[class*='language-'],\npre[class*='language-'] {\n  background: #1d1f21;\n}\n\n/* Inline code */\n:not(pre) > code[class*='language-'] {\n  padding: 0.1em;\n  border-radius: 0.3em;\n}\n\n.token.prolog {\n  color: rgb(0, 0, 128);\n}\n\n.token.parameter {\n  color: rgb(255, 255, 255);\n}\n\n.token.comment {\n  color: rgb(106, 153, 85);\n}\n\n.token.doctype {\n  color: rgb(191, 199, 213);\n}\n\n.token.cdata {\n  color: rgb(191, 199, 213);\n}\n\n.token.punctuation {\n  color: rgb(136, 198, 190);\n}\n\n.token.property {\n  color: rgb(252, 146, 158);\n}\n\n.token.tag {\n  color: rgb(252, 146, 158);\n}\n\n.token.class-name {\n  color: rgb(250, 200, 99);\n}\n\n.token.boolean {\n}\n\n.token.constant {\n  color: rgb(100, 102, 149);\n}\n\n.token.symbol {\n  color: rgb(141, 200, 145);\n}\n\n.token.deleted {\n  color: rgb(141, 200, 145);\n}\n\n.token.number {\n  color: rgb(181, 206, 168);\n}\n\n.token.inserted {\n  color: rgb(181, 206, 168);\n}\n\n.token.selector {\n  color: rgb(215, 186, 125);\n}\n\n.token.char {\n  color: rgb(209, 105, 105);\n}\n\n.token.builtin {\n  color: rgb(197, 165, 197);\n}\n\n.token.changed {\n  color: rgb(197, 165, 197);\n}\n\n.token.keyword {\n  color: rgb(197, 165, 197);\n}\n\n.token.string {\n  color: rgb(195, 232, 141);\n}\n\n.token.attr-name {\n  color: rgb(156, 220, 254);\n}\n\n.token.variable {\n  color: rgb(156, 220, 254);\n}\n\n.token.operator {\n  color: #ededed;\n}\n\n.token.entity {\n  color: #ffffb6;\n  cursor: help;\n}\n\n.token.url {\n  color: #96cbfe;\n}\n\n.language-css .token.string,\n.style .token.string {\n  color: #87c38a;\n}\n\n.token.atrule,\n.token.attr-value {\n  color: #f9ee98;\n}\n\n.token.function {\n  color: rgb(121, 182, 242);\n}\n\n.token.regex {\n  color: #e9c062;\n}\n\n.token.important {\n  color: #fd971f;\n}\n\n.token.important,\n.token.bold {\n  font-weight: bold;\n}\n\n.token.italic {\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
